<template>
  <div id="delivery" style="box-shadow: rgba(0, 0, 0, 0.3) 0px 20px 22px 0px;">

    <button @click="$emit('close')" v-if="showCloseButton"
            type="button" data-dismiss="modal" aria-label="Close" class="close"
            style="width: 30px; height: 30px; border-radius: 30px; font-size: 30px; background: gray;"><span
      aria-hidden="true">×</span>
    </button>

    <div>
      <div class="xs-flex text-glitch-fix" v-if="!hasDisposition">
        <div data-auto-tag="localisation-delivery" data-item-type="tool" data-item-position="1"
             data-synth="form-delivery" data-type="DELIVERY"
             class="order-type-button xs-flex-center xs-flex-auto xs-min-width-0 xs-self-end xs-p-10 bold rounded-top no-outline xs-nowrap text-glitch-fix xs-width-50 xs-fill-white"
             v-bind:class="isDelivery" role="button" style="margin-right: 10px; font-size: 18px;" tabindex="0"
             v-on:click="clickActiveDelivery">
          <i class="icon-delivery xs-mr-5 "></i><span>{{$t('delivery')}}</span>
        </div>
        <div data-auto-tag="localisation-takeaway" data-item-type="tool" data-item-position="2"
             data-synth="form-collection" data-type="CARRYOUT"
             class="order-type-button xs-flex-center xs-flex-auto xs-min-width-0 xs-self-end xs-p-10 bold rounded-top no-outline xs-nowrap text-glitch-fix xs-width-50 xs-fill-white"
             v-bind:class="isCollection" role="button" style="font-size: 18px;" tabindex="0"
             v-on:click="clickActiveCollection">
          <i class="icon-collection xs-mr-5"></i><span>{{$t('collection')}}</span>
        </div>
      </div>
      <div class="localisation xs-fill-fcfcfc xs-fill-white pt-10" v-if="!hasDisposition">
        <div v-if="$auth.check()">
          <div v-show="orderType == $const.DELIVERY && customer.list_address.length > 0">
            <div class="pl-20 pr-20">
              <v-select :multiple="false" :options="customer.list_address" class="select-localization"
                        :placeholder="txtSelectedAddr"
                        @input="setSelectedAddress"></v-select>
            </div>
          </div>
          <div v-show="orderType == $const.CARRYOUT && customer.list_store.length > 0">
            <!--            <div class="xs-pb-15 xs-fill-red xs-text-white fw600 xs-p-10 xs-mb-10 arrow-bottom-red typo-l6b "-->
            <!--                 v-if="$route.query.isShowWarning && $route.query.isShowWarning == 1">-->
            <!--              <span>{{$t('home.'+orderType.toLowerCase()+'.popup_select_local')}}</span>-->
            <!--            </div>-->
            <div class="pl-20 pr-20">
              <v-select :multiple="false" :options="customer.list_store" class="select-localization"
                        :placeholder="txtSelectedStore"
                        @input="setSelectedStore"></v-select>
            </div>
          </div>
        </div>
        <!--        <div class="xs-pb-15 xs-fill-red xs-text-white fw600 xs-p-10 xs-mb-10 arrow-bottom-red typo-l6b "-->
        <!--             v-if="$route.query.isShowWarning && $route.query.isShowWarning == 1 && ((customer.list_address.length <= 0 && orderType == $const.DELIVERY) || (customer.list_store.length <= 0 && orderType == $const.CARRYOUT))">-->
        <!--          <span>{{$t('home.'+orderType.toLowerCase()+'.popup_select_local')}}</span>-->
        <!--        </div>-->
        <div class="xs-pb-15 xs-fill-yellow xs-text-black xs-p-10 xs-mb-10 arrow-bottom-yellow typo-l6b top-warning"
             :class="collection ? 'collection' : '' "
             v-if="$route.query.isShowWarning && $route.query.isShowWarning == 1">
          <span class="switch-device--desktop">{{$t('home.'+orderType.toLowerCase()+'.popup_select_local')}}</span>
          <span
            class="switch-device--mobile">{{$t('home.'+orderType.toLowerCase()+'.popup_select_local_mobile')}}</span>
        </div>
        <div class="clearfix"></div>
        <div v-if="messagePopup.length >0" class="pt-10">
          <p class="pl-10 pr-10 flex1 display-flex items-center">
            <span class="xs-text-red">{{messagePopup}}</span>
          </p>
        </div>
        <div class="clearfix"></div>
        <div v-if="message.length >0" class="pt-10">
          <p class="pl-10 pr-10 flex1 display-flex items-center">
            <span class="xs-text-red">{{message}}</span>
          </p>
        </div>
        <div class="clearfix"></div>
        <div v-if="orderType == $const.DELIVERY">
          <!--<p> <span class="fw600">{{$t('localization.search_by_zip')}}</span></p>-->
          <div class="pl-10 pr-10 xs-pb-15 xs-text-red xs-p-10typo-l6b pl-15" style="padding-top: 5px !important;"
               v-if="errorPostalCode.length > 0">
            <span>{{$t(errorPostalCode)}}</span>
          </div>
          <div class="xs-flex xs-z-300 p-10 pt-5" style="padding-bottom: 0">
            <span
              class="buttonload button  flex-1 t13 min-height-59 left-icon-address left-icon-address--v2 cursor-context-menu">
              <img src="../../assets/images/icons/zipcode.png"/>
            </span>
            <div
              class="xs-flex xs-justify-between xs-items-end xs-relative xs-z-300 xs-fill-white xs-items-center width-full">
              <zipcode-input
                class="search search--hut input xs-border-none fw600"
                name="zipcode"
                v-on:update-zip-code="updateZipcodeValue"
                v-on:search-by-zipcode="searchByZipCode"
              ></zipcode-input>
              <!--<input
                     id="zipcode_autocomplete" @keyup.enter="searchByZipCode"
                     data-synth="zipcode-input" autocomplete="off" autocorrect="off"
                     autocapitalize="off" maxlength="7"
                     spellcheck="false" v-bind:placeholder="$t('localization.placehover_zipcode')" value=""
                     type="phone" v-model="searchZipCode" data-hj-whitelist/>-->
              <div class="btn--delivery-submit">
                <a href="javascript: void(0)" class="buttonload flex-1 xs-flex-column min-height-59" v-if="loadingZip"
                   style="border-radius: 3px;line-height: 1">
                  <i class="fa fa-refresh fa-spin"></i>{{$t('button_loading')}}
                </a>
                <a href="javascript: void(0)" data-item-id="localisation-submit" data-item-type="tool"
                   data-item-position="3" class="btn btn--primary btn--xlg pt-10"
                   style="border-radius: 3px;line-height: 1" v-else @click="searchByZipCode">
                  <div class="fw-normal mb-5">{{$t('order_now')}}</div>
                  <div class="text-yellow fw-normal t10">送料無料！</div>
                </a>
              </div>
            </div>
          </div>
          <hr v-if="showDefaultSearchDelivery">
        </div>

        <!-- ########### INPUT address-->
        <!--DELIVERY-->
        <div v-if="orderType == $const.DELIVERY">
          <div v-if="!showDefaultSearchDelivery">
            <div class="home-icon-default" @click="switchSearchByAddress">
              <img src="../../assets/images/icons/home-delivery-icon.svg"/>
              <span class="ml-5">{{$t('localization.search_by_address_short')}}</span>
            </div>
          </div>
          <div class="xs-flex xs-z-300 p-10 " style="padding-top: 0" v-else>
              <span class="buttonload button  flex-1 t13 min-height-59 left-icon-address cursor-context-menu">
                <img src="../../assets/images/icons/add.png"/>
              </span>
            <div
              class="xs-flex xs-items-end xs-border xs-border-gray-light xs-border-1 rounded xs-relative xs-z-300 xs-fill-white xs-mb-10 xs-items-center width-full"
            >
              <div class="xs-flex-1  min-height-59">
                <input class="search search--hut input xs-border-none xs-py-10 xs-px-10 min-height-59 fw600"
                       @focus="inputSearchFocus()"
                       data-synth="address-input" name="address" autocomplete="off" autocorrect="off"
                       autocapitalize="off"
                       @keyup.enter="searchByAddress"
                       spellcheck="false" v-bind:placeholder="$t('localization.placehover_search_by_address')" value=""
                       type="text" v-model="searchAutoComplete" data-hj-whitelist/>
              </div>
              <a href="javascript: void(0)" v-if="searchAutoComplete.length > 0 && !loadingFreeText">
                <button class="flex-1 t13 min-height-59 pl-10 pr-10" @click="clearText">
                  <img src="../../assets/images/icons/delete.png"/>
                </button>
              </a>
              <div>
                <a href="javascript: void(0)" class="buttonload button button--primary flex-1 t13 min-height-59"
                   style="width: 44px;border-radius: 3px" v-if="loadingFreeText">
                  <i class="fa fa-refresh fa-spin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!--./DELIVERY-->

        <!--CARRY OUT-->
        <div class="xs-flex xs-z-300 p-10 pt-6" v-if="orderType == $const.CARRYOUT">
            <span class="buttonload button  flex-1 t13 min-height-59 left-icon-address cursor-context-menu">
              <img src="../../assets/images/icons/mix.png"/>
            </span>
          <div
            class="xs-flex xs-items-end xs-border xs-border-gray-light xs-border-1 rounded xs-relative xs-z-300 xs-fill-white xs-mb-10 xs-items-center width-full"
            :class="{'ml-5':orderType == $const.CARRYOUT }" style="flex-direction: column">
            <div class="min-height-59 disposition-carryout-box">
              <input
                class="search search--hut input xs-border-none xs-py-10 xs-px-10 min-height-59 fw600"
                id="address-autocomplete"
                data-synth="address-input" name="address" autocomplete="nope" autocorrect="off"
                autocapitalize="off" @keyup.enter="getLatLog"
                spellcheck="false" v-bind:placeholder="$t('localization.placehover_search_by_address_postcode')"
                value="" type="text" v-model="searchAutoComplete" data-hj-whitelist/>

              <a href="javascript: void(0)" v-if="searchAutoComplete.length > 0 && !loadingFreeText">
                <button class="flex-1 t13 min-height-59 pl-10 pr-10" @click="clearText">
                  <img src="../../assets/images/icons/delete.png"/>
                </button>
              </a>
              <div>
                <a href="javascript: void(0)" data-item-id="localisation-submit" style="border-radius: 3px;line-height: 4"
                   data-item-type="tool" data-item-position="3" class="btn btn--primary btn--lg"
                   v-if="orderType == $const.CARRYOUT" @click="getLatLog">
                  <div class="flex w-full flex-col t14">{{$t('button_search')}}</div>
                </a>
                <a href="javascript: void(0)" class="buttonload btn btn--primary btn--lg"
                   style="width: 44px;border-radius: 3px" v-if="loadingFreeText">
                  <i class="fa fa-refresh fa-spin"></i>
                </a>

              </div>
            </div>
            <div class="use_my_location_block pl-10 pr-10">
              <button data-item-id="localisation-auto" data-item-type="tool" data-item-position="4"
                      v-if="searchAutoComplete.length <= 0"
                      class="trigger-location use-current-location flex"
                      v-on:click="useMyLocation" style="color: #4a90e2">
                      <i class="icon-geo mr-10" style="align-self: center"></i>
                {{$t('using_my_local_carryout')}}
              </button>
              <a href="javascript:void(0)" class="cursor-pointer cl-78838c border-b t13 pull-right decoration-none"
                 v-if="outletList.length > 1" v-on:click="showHideMap(mapOpen)">{{ $t('button_open_maps')}}</a>
            </div>
            <div class="contain-outlet" v-if="mode=='location'">
              <ul class="list-outlets" v-if="(outletList.length > 0 && searchAutoComplete.length >0) && !localisation_message">
                <li v-for="(outlet,index) in outletList" :key="index" class="outlet-item inactive text-black"
                    v-bind:class="{highlight: index == highlight}" @click="clickChosenOutlet(outlet)">
                  <h4> {{index +1}}. <span class="text-capitalize">{{outlet.name}}{{$session.get('lang') == 'en' ? ' ': '' }}{{ $t('store')}}</span><span
                    class="t12"> ( {{formatNum2Fix(outlet.distance)}} km )</span></h4>
                  <p>{{outlet.address}}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--./CARRY OUT-->
        <!-- ./ ########### INPUT address-->
        <div class="clearfix"></div>
        <div class="contain-outlet" v-if="mode=='free'">
          <ul class="list-outlets" v-if="(addressList.length > 0 && searchAutoComplete.length >0) && !localisation_message">
            <li v-for="(outlet,index) in addressList" :key="index" class="outlet-item inactive text-black"
                @click="clickChosenAddress(outlet)">
              <h4><span class="text-capitalize"><i
                class="fa fa-map-marker "></i> {{ convertString(outlet.address) }} <span class="fw400 t13 "
                                                                                         style="color: #404046">{{outlet.custom}}</span></span>
              </h4>
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="localisation xs-fill-fcfcfc rounded-bottom xs-fill-white " style="border-radius: 4px"
           v-if="hasDisposition">
        <div class="p-10">
          <div v-if="$i18n.locale == $const.LANG_JP">
            <p>
              <b class="border-b">
                {{getDeliveryInfo(this).addressInfo}}
              </b>
              <span class="t14">{{$disposition.getByKey(this, 'orderType', '') == $const.DELIVERY ? $t('delivery_to') : $t('take_away')}}</span>
            </p>
          </div>
          <div v-else>
            <p>
              <span class="t14">{{$disposition.getByKey(this, 'orderType', '') == $const.DELIVERY ? $t('delivery_to') : $t('take_away')}}</span>
              <span class="border-b">
              {{getDeliveryInfo(this).addressInfo}}
            </span>
            </p>
          </div>
          <div class="p-10 pb-0">
            <button class="btn btn--secondary btn--lg w-full"
                    @click="resetDisposition"> {{$t('button_change')}}
            </button>
          </div>
          <div class="p-10">
            <button v-on:click="viewMenu" class="btn btn--primary btn--lg w-full" style="min-height: 42px">
              {{$t('home.button_view_all_deal')}}
            </button>

            <!--
                        <button v-on:click="$root.$emit('onProcessChangeCategory')" class="btn btn-success w-full" style="min-height: 42px"> {{$t('home.button_view_all_deal')}}</button>
            -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.query.isShowWarning && $route.query.isShowWarning == 1" class="black-modal"
         @click="removeBlackModal()">
    </div>
    <div v-if="!hasDisposition">
      <div class="localisation xs-fill-white localisation-mesage" :class="(localisation_message && geo_message_error) ? 'pb-15' : ''">
        <span ref="errorLocalisation" id="errorLocalisation" v-html="localisation_message"></span>
      </div>
      <div class="localisation xs-fill-white localisation-mesage" :class="(!localisation_message && geo_message_error) ? 'pb-15' : ''">
        <span ref="errorLocalisation" id="errorLocalisation" v-html="geo_message_error"></span>
      </div>
      <div v-if="localisation_message"
           class="localisation xs-fill-white localisation-mesage">
        <div v-if="!switchToCollection && !switchToDelivery">
          <button class="btn btn-success w-full mt-15" style="min-height: 42px" @click="handleAction()">
            {{$t('btn_pre_order')}}
          </button>
          <button class="w-full text-green" style="min-height: 42px;"
                  @click="changeAddress()"> {{$t('button_change')}}
          </button>
        </div>
      </div>
      <div v-if="openingDateTime && hours.length > 0" class="localization-timeslot localisation xs-fill-white p-15">
        <div class="localization-timeslot-title font-sharp-sans-bold">{{$t('what_time_would_you_like_your_order')}}</div>
        <div class="time-slots">
          <select class="select-popup-date-time t16 arrow-dropdown-time mr-5" v-model="choiceDay">
            <option class="option-time-slots" v-for="(item, index) in openingDateTime" :value="index">{{
              item.label }}
            </option>
          </select>
          <select class="select-popup-date-time t16 arrow-dropdown-time ml-5" v-model="choiceHour">
            <option class="option-time-slots" v-for="hour in hours" :value="hour">{{hour}}
            </option>
          </select>
        </div>
        <button class="btn btn-success w-full mt-15" style="min-height: 42px" @click="setTime()">
          {{$t('btn_pre_order')}}
        </button>
        <button class="w-full text-green" style="min-height: 42px;"
                @click="changeAddress()"> {{$t('button_change')}}
        </button>
      </div>
      <div v-if="switchToCollection || switchToDelivery" class="p-15 xs-fill-white">
        <button v-if="switchToCollection" class="btn btn-success w-full mt-15" style="min-height: 42px"
                @click="clickActiveCollection()">
          {{$t('btn_switch_to_collection')}}
        </button>
        <button v-if="switchToDelivery" class="btn btn-success w-full mt-15" style="min-height: 42px"
                @click="clickActiveDelivery()">
          {{$t('btn_switch_to_delivery')}}
        </button>
      </div>
      <div v-if="geoMessage" class="p-15 xs-fill-white">
        <div class="geo-message-content">
          <i class="fa fa-exclamation-circle fa-lg icon-noti-geo mr-5"></i>
          <div class="geo-message">
            <div class="geo-message-title font-sharp-sans-bold pb-5">{{$t('geo_notification_title')}}</div>
            <div class="geo-message-body">{{geoMessage}}</div>
          </div>
        </div>
        <button v-if="switchToCollection" class="btn btn-success w-full mt-15" style="min-height: 42px"
                @click="clickActiveCollection()">
          {{$t('btn_switch_to_collection')}}
        </button>
        <button v-if="switchToDelivery" class="btn btn-success w-full mt-15" style="min-height: 42px"
                @click="clickActiveDelivery()">
          {{$t('btn_switch_to_delivery')}}
        </button>
        <button class="btn btn-success w-full mt-15" style="min-height: 42px" @click="useMyLocation()">
          {{$t('btn_geo_ask_open')}}
        </button>
        <button class="w-full text-green" style="min-height: 42px;"
                @click="geoMessage = ''"> {{$t('btn_geo_not_now')}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import ConfirmOrderAdvance from '../popup/ConfirmOrderAdvance.vue'
  import ASAPPopup from '../popup/OrderASAP.vue'
  import ModalCarryout from '../popup/ModalCarryout.vue'
  import ModalDelivery from '../popup/ModalDelivery.vue'
  import ModalMap from '../popup/ModalMaps.vue'
  import ModalDrawMap from '../popup/ModalDrawMaps'
  import vSelect from 'vue-select'
  import * as types from '@/store/types'
  import {
    mapActions
  } from 'vuex'
  import ZipcodeInput from '../partials/ZipcodeInput'

  let active = 'xs-fill-fcfcfc xs-text-red xs-relative xs-z-200 xs-py-15'
  let inactive = 'xs-fill-gray-lightest xs-text-gray-medium xs-grayscale'
  export default {
    name: 'localization',
    props: ['showCloseButton', 'isReInitHeader', 'isPopup', 'currentPath'],
    mounted() {
      var vm = this
      window.infowindowClick = function (index) {
        vm.infowindowClick(index)
      }

      this.tracklocalization()
      this.$disposition.init(this)
      this.$root.$on('onChangeOutlet', (index) => {
        vm.onChangeOutlet(index)
      })
      this.$root.$on('onclickChosenOutlet', (outlet) => {
        vm.clickChosenOutlet(outlet)
      })
      this.$root.$on('onTriggerOrder', () => {
        vm.triggerOrder()
      })
      this.$root.$on('activeCollectionMap', () => {
        this.clickActiveCollection()
        this.searchLocation = true
        this.searchAutoComplete = this.addressSelected
      })
      this.$root.$on('onCheckValidOutlet', (data) => {
        vm.checkValidOutlet()
      })

      if (this.$auth.check()) {
        this.initCustomerList()
      }

      if (this.$session.get('orderType')) {
        this.orderType = this.$session.get('orderType');

        if (this.orderType == this.$const.DELIVERY) {
          this.isDelivery = active
          this.isCollection = inactive
        } else {
          this.isDelivery = inactive
          this.isCollection = active
        }
      }
      if (this.$route.query.store_code) {
        this.localisationDirectlyTakeaway(this.$route.query.store_code)
      }
      this.$root.$on('activeTabLocalization', (type) => {
        if (type === vm.$const.DELIVERY) {
          vm.clickActiveDelivery()
        } else if (type === vm.$const.CARRYOUT) {
          vm.clickActiveCollection()
        }
      })
      this.checkGeoLocation()
    },
    beforeDestroy() {
      this.$root.$off('onChangeOutlet')
      this.$root.$off('onclickChosenOutlet')
      this.$root.$off('onTriggerOrder')
      this.$root.$off('activeCollectionMap')
      this.$root.$off('onCheckValidOutlet')
      this.$root.$off('activeTabLocalization')
    },
    created: function () {
      this.debouncedInput = this._.debounce(this.afterDebounce, 240)
      this.showDefaultSearchDelivery = false
    },
    watch: {
      searchZipCode: function (newValue, oldValue) {
        this.loadScriptMap()
        this.clearMessage()
        this.errorPostalCode = ''
        this.localisation_message = ''
      },
      searchAutoComplete: function (newValue, oldValue) {
        if(newValue && (newValue !== this.searchZipCode)) {
          this.clearMessage()
        }
        this.errorPostalCode = ''
        this.localisation_message = ''
        if (!this.searchLocation) {
          this.loadScriptMap()
          this.debouncedInput()

          if (!this.searchAutoComplete) {
            this.clearOutlet()
          }
        }
      }
    },
    data() {
      return {
        deliveryInfo: this.getDeliveryInfo(this),
        customer: {
          list_address: [],
          list_store: []
        },
        delivery: true,
        collection: false,
        hasDisposition: this.checkPosition(this),
        errorPostalCode: '',
        highlight: null,
        locationCenter: {lat: 0, lng: 0},
        searchLocation: false,
        isDelivery: active,
        isCollection: inactive,
        orderType: this.$const.DELIVERY,
        isShow: this.checkPosition(this),
        searchAutoComplete: '',
        searchZipCode: '',
        outletList: [],
        addressList: [],
        mode: '',
        loadingFreeText: false,
        loadingZip: false,
        result: {},
        message: '',
        messagePopup: '',
        geocoder: {},
        map: {},
        marker: {},
        markers: [],
        addressAutoComplete: false,
        addressSelected: '',
        mapOpen: false,
        locationObject: {
          lat: 0,
          lng: 0
        },
        disposition: {},
        txtSelectedAddr: this.$t('home.saved_address'),
        txtSelectedStore: this.$t('home.saved_store'),
        showDefaultSearchDelivery: false,
        localisation_message: "",
        selected: null,
        timezone: null,
        choiceDay: '',
        choiceHour: '',
        openingDateTime: {},
        hours: {},
        openingList: [],
        showPopupTime: false,
        switchToDelivery: false,
        switchToCollection: false,
        geoMessage: '',
        geo_message_error: ''
      }
    },
    methods: {
      ...mapActions({
        setDisposition: types.SET_DISPOSITION,
        setShowModalTakeAwayLess: types.SET_SHOW_MODAL_TAKE_AWAY_LESS,
      }),
      localisationDirectlyTakeaway(code) {
        var vm = this
        vm.callEventBus(vm.$const.EVENT_BUS.LOADING, true)
        this.axios.apiOutlet.getOutLetByCode({code: code}, function (response) {
          vm.$session.remove('cart')
          vm.$session.remove('disposition')
          vm.setDisposition({})
          vm.$root.$emit('cartUpdate')
          vm.hasDisposition = false
          vm.$root.$emit('onReInitHeader')
          vm.result = {}
          let outletInfo = response.data.data.item
          vm.result.lat = outletInfo.lat
          vm.result.takeaWayLess = 1
          vm.result.long = outletInfo.long
          vm.result.outletAddress = outletInfo.address
          vm.result.orderType = vm.$const.CARRYOUT
          vm.result.outletId = outletInfo.id
          vm.result.outletName = outletInfo.name
          vm.result.outletCode = outletInfo.code
          vm.result.tier = outletInfo.tier

          vm.orderType = vm.$const.CARRYOUT
          vm.checkValidOutlet()
          vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
        }, function (error) {
          vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
        })
        if(this.isPopup)
          this.$emit('close')
      },
      viewMenu() {
        this.$store.commit('setCategoryUuid', null)
        // this.redirectToPage(this.$const.SLUG_LIST.DEAL, this.$route.query)
        this.redirectToMenuPage()
      },
      removeBlackModal() {
        document.getElementById('user-top-mobile').classList.remove('hide-top')
        this.$router.push('/')
      },
      tracklocalization() {
        let layer = {
          'assets': {
            'tools': [
              {
                'id': 'localisation-delivery',
                'type': 'storefinder',
                'name': 'delivery-tab',
                'attributes': {
                  'function': 'show-delivery-tab'
                }
              },
              {
                'id': 'localisation-takeaway',
                'type': 'storefinder',
                'name': 'takeaway-tab',
                'attributes': {
                  'function': 'show-takeaway-tab'
                }
              },
              {
                'id': 'localisation-submit',
                'type': 'storefinder',
                'name': 'submit-button',
                'attributes': {
                  'function': 'submit-location-search'
                }
              },
              {
                'id': 'localisation-auto',
                'type': 'storefinder',
                'name': 'auto-locate-button',
                'attributes': {
                  'function': 'auto-locate-user'
                }
              }
            ]
          }
        }
        this.eventTrackingModule(layer)
      },
      initCustomerList() {
        var vm = this
        this.axios.apiCustomer.getProfile((response) => {
          let data = []
          for (let i in response.data.data.item.locations) {
            data.push({
              label: response.data.data.item.locations[i].display_address,
              code: response.data.data.item.locations[i]

            })
          }
          let dataStore = []
          for (let j in response.data.data.item.outlets) {
            dataStore.push({
              label: response.data.data.item.outlets[j].outlet_name,
              code: response.data.data.item.outlets[j]

            })
          }
          vm.customer.list_address = data
          vm.customer.list_store = dataStore
        })
      },
      setSelectedStore(value) {
        if (!value) {
          return
        }
        var vm = this
        vm.result = {}
        this.axios.apiOutlet.getOutLetByCode({code: value.code.outlet_code}, (response) => {
          let data = response.data.data.item
          if (data) {
            vm.clickChosenOutlet(data)
          } else {
            vm.$notify({
              type: 'warn',
              title: vm.$t('warning_store_invalid')
            })
          }
        })
      },
      setSelectedAddress(value) {
        if (!value) {
          return
        }
        var vm = this
        vm.result = {}
        vm.result.locationName = value.code.location
        vm.result.addressCode = value.code.location_code
        vm.result.orderType = this.$const.DELIVERY
        vm.result.houseNo = value.code.house_no
        vm.result.landmark = value.code.landmark
        vm.result.unitNo = value.code.unit_no

        this.axios.apiOutlet.getAddressByAddressCode({address_code: value.code.location_code}, (response) => {
          let data = response.data.data.items
          if (data.length > 0) {
            vm.result.prefectureName = data[0].level1 || ''
            vm.result.cityName = data[0].level2 || ''
            vm.result.villeageName = data[0].level3 || ''
            vm.result.st = data[0].level4 || ''
            vm.result.outletId = data[0].outlet_id
            data.outletCode = data[0].outlet_code
            let address = [vm.convertString(vm.result.prefectureName), vm.convertString(vm.result.cityName), vm.convertString(vm.result.villeageName), vm.convertString(vm.result.st)]
            vm.result.outletAddress = address.join(', ')

            vm.checkValidOutlet()
          } else {
            vm.$notify({
              type: 'warn',
              title: vm.$t('warning_address_invalid')
            })
          }
        })
      },
      resetDisposition() {
        var vm = this
        vm.$modal.show('dialog', {
          text: vm.$t('confirm_change_disposition'),
          buttons: [
            {
              title: vm.$t('button_yes'),
              handler: () => {
                vm.$modal.hide('dialog')
                this.$session.remove('cart')
                this.$session.remove('disposition')
                vm.setDisposition({})
                this.$root.$emit('cartUpdate')
                this.hasDisposition = false
                if (this.isReInitHeader) {
                  this.$root.$emit('collectionTimeUpdate')
                }

                vm.$root.$emit('onReInitHeader')
              }
            },
            {
              title: vm.$t('button_close')
            }
          ]
        })
      },
      afterDebounce() {
        if (this.orderType == this.$const.DELIVERY) {
          this.searchByAddress()
        } else {
          this.initAutoCompleteSearch()
        }
      },
      clearText() {
        this.searchAutoComplete = ''
        this.clearOutlet()
      },
      clearOutlet() {
        this.outletList = []
        this.addressList = []
      },
      clearMessage() {
        this.messagePopup = ''
        this.message = ''
      },
      inputSearchFocus() {
        if (this.searchAutoComplete) {
          if (this.orderType == this.$const.DELIVERY) {
            this.searchByAddress()
          }
        }
      },
      showHideMap(flag) {
        this.mapOpen = !flag
        if (this.mapOpen) {
          // let element1 = document.getElementById('mapLocalization')
          this.$modal.show(ModalMap, {outletList: this.outletList}, {height: 'auto'}, {
            'opened': this.beforeOpen,
            'before-close': this.beforeClose
          })
        } else {
          this.$root.$emit('onCloseMap')
        }
      },
      showDrawMap(lat, lng) {
        this.locationObject.lat = lat
        this.locationObject.lng = lng
        this.evenTrackingNotInDeliveryZone(this.searchAutoComplete, lat, lng)
        this.$modal.show(ModalDrawMap, {lat: '', log: ''}, {height: 'auto', classes: 'draws-modal v--modal'}, {
          'opened': this.beforeOpenDraw,
          'before-close': this.beforeCloseDraw
        })
      },
      /**
       *  Intit google map
       * */
      initMap() {
        this.map = new google.maps.Map(document.getElementById('mapLocalization'), {
          center: {lat: -34.397, lng: 150.644},
          zoom: 15,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          mapTypeControl: false
        })
      },
      initAutoCompleteSearch() {
        var vm = this
        let element = document.getElementById('address-autocomplete')
        if (typeof google !== 'undefined' && typeof (element) !== 'undefined' && element != null && !this.addressAutoComplete) {
          this.addressAutoComplete = new google.maps.places.Autocomplete(
            (document.getElementById('address-autocomplete')),
            {types: ['geocode'], componentRestrictions: {country: this.$const.COUNTRY_CODE}}
          )
          this.addressAutoComplete.addListener('place_changed', () => {
            let place = this.addressAutoComplete.getPlace()
            vm.searchAutoComplete = document.getElementById('address-autocomplete').value
            if (!place || (typeof place.place_id === 'undefined' && typeof place.geometry === 'undefined')) {
              return
            }
            let lat = place.geometry.location.lat()
            let lng = place.geometry.location.lng()
            let myLatLng = lat + ',' + lng
            let objAddress = {
              address: 'My Location',
              latlng: myLatLng,
              lat: lat,
              lng: lng,
              place_id: place.place_id
            }
            vm.getDataFromGG(objAddress)
          })
        }
      },
      /**
       * Get data from google
       * */
      getDataFromGG(address) {
        var vm = this
        if (address.address.length <= 0) {
          return false
        }
        if (typeof address.lat !== 'undefined' && typeof address.lng !== 'undefined') {
          vm.searchByLocation(address.lat, address.lng)
          return false
        }
        var data = {}
        data.address = (address.address || '')
        data.sensor = false
        data.key = this.$const.GOOGLE_MAP_API_KEY
        data.types = 'address'
        data.components = vm.$const.COUNTRY_CODE_COMPONENT // 'country:jp'
        if (typeof address.place_id !== 'undefined' && address.place_id.length > 0) {
          delete data.address
          delete data.types
          delete data.components
          delete data.latlng
          data.place_id = address.place_id
        } else if (typeof address.latlng !== 'undefined' && address.latlng.length > 0) {
          delete data.address
          delete data.types
          delete data.components
          data.latlng = address.latlng
        }
        delete this.axios.defaults.headers.common['Lang']
        delete this.axios.defaults.headers.common['Client']
        this.axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
          params: data
        })
          .then(function (response) {
            vm.setData(response.data.results)
            let lat = vm.result.lat
            let lng = vm.result.long
            if (lat != '' && lng != '') {
              vm.searchByLocation(lat, lng)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
            // always executed
            vm.axios.defaults.headers.common['Lang'] = vm.$i18n.locale
            vm.axios.defaults.headers.common['Client'] = vm.$session.set('client')
          })
      },
      /**
       * Click on Delivery tab
       * */
      clickActiveDelivery() {
        this.searchAutoComplete = ''
        this.addressAutoComplete = false
        this.isDelivery = active
        this.isCollection = inactive
        this.orderType = this.$const.DELIVERY
        this.clearMessage()
        this.addressList = []
        this.outletList = []
        this.delivery = true
        this.collection = false
        this.$root.$emit('onChangeTab', this.orderType.toLowerCase());

        this.$session.set('orderType', this.$const.DELIVERY);
      },
      /**
       * Click on Collection tab
       * */
      clickActiveCollection() {
        this.searchAutoComplete = ''
        this.loadScriptMap()
        this.initGeocoder()
        this.isDelivery = inactive
        this.isCollection = active
        this.orderType = this.$const.CARRYOUT
        this.clearMessage()
        this.addressList = []
        this.outletList = []
        this.delivery = false
        this.collection = true
        this.$root.$emit('onChangeTab', this.orderType.toLowerCase())

        this.$session.set('orderType', this.$const.CARRYOUT);
      },
      onActiveCollectionForSuggestStore() {
        this.isDelivery = inactive
        this.isCollection = active
        this.orderType = this.$const.CARRYOUT
        this.delivery = false
        this.collection = true
        this.addressList = []
        this.$root.$emit('onChangeTab', this.orderType.toLowerCase())
        this.$session.set('orderType', this.$const.CARRYOUT);
        this.mode = 'location'
      },
      infowindowClick(index) {
        let outlet = this.outletList[index]
        this.clickChosenOutlet(outlet)
      },
      onChangeOutlet(index) {
        let flag = false
        if (this.locationCenter.lat != 0 && this.locationCenter.lng != 0) {
          flag = true
          index += 1
        }
        for (let i in this.markers) {
          if (i == 0 && flag) continue
          let url = this.markers[i].originIcon
          if (i == index) {
            url = this.markers[i].hoverIcon
          }
          this.markers[i].setIcon({
            url: url,
            scaledSize: new google.maps.Size(40, 40)
          })
        }
        if (this.markers.length > 0) {
          this.map.panTo(this.markers[index].position)
        }
      },
      /**
       * Using your location for show google map
       * */
      useMyLocation() {
        var vm = this
        vm.clearMessage()
        vm.searchLocation = true
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            vm.getAddressByLatLog({
              lat: parseFloat(position.coords.latitude),
              lng: parseFloat(position.coords.longitude)
            })
            vm.geoMessage = ''
            vm.searchByLocation(position.coords.latitude, position.coords.longitude)
            vm.locationCenter.lat = position.coords.latitude
            vm.locationCenter.lng = position.coords.longitude
          }, function (error) {
            vm.geoMessage = ''
            if (error.code == error.PERMISSION_DENIED) {
              vm.messagePopup = vm.$t('message_geolocation_denied')
            }
          })
        }
      },
      initGeocoder() {
        console.log('google: ', typeof google);
        if (typeof google !== 'undefined') {
          this.geocoder = new google.maps.Geocoder()
        }
      },
      /**
       * Get lat long from address
       * */
      getAddressByLatLog(latLong) {
        var vm = this
        vm.locationCenter.lat = latLong.lat
        vm.locationCenter.lng = latLong.lng
        vm.initGeocoder()
        vm.searchLocation = true
        this.geocoder.geocode({'location': latLong}, function (results, status) {
          if (status === 'OK') {
            if (results[0]) {
              vm.searchAutoComplete = results[0].formatted_address
            }
          }
        })
      },
      /**
       * Get lat long from address
       * */
      getLatLog() {
        this.clearMessage()
        var vm = this
        let geocoder = new google.maps.Geocoder()
        geocoder.geocode({'address': this.searchAutoComplete}, function (results, status) {
          if (status === 'OK') {
            let lat = results[0].geometry.location.lat()
            let lng = results[0].geometry.location.lng()

            vm.searchByLocation(lat, lng)
          } else {
            vm.clearOutlet()
            vm.message = vm.$t('localization.location_404')
          }
        })
      },
      /**
       * Chosen a address
       * */
      clickChosenOutlet(outlet) {
        this.result = {}
        this.clearMessage()
        if (outlet) {
          var vm = this
          vm.result.lat = outlet.lat
          vm.result.long = outlet.long
          vm.result.outletAddress = outlet.address
          vm.result.orderType = vm.$const.CARRYOUT
          vm.result.outletId = outlet.id
          vm.result.outletName = outlet.name
          vm.result.outletCode = outlet.code
          vm.result.tier = outlet.tier
          vm.checkValidOutlet()
        } else {
          vm.messagePopup = vm.$t('message_find_outlet_empty')
        }
      },
      /**
       * Chosen a address
       *
       * */
      clickChosenAddress(outlet) {
        this.result = {}
        this.clearMessage()
        if (outlet) {
          if (this.orderType == this.$const.DELIVERY) {
            this.searchAutoComplete = outlet.address
            this.addressSelected = outlet.address
            if (outlet.storenumber && outlet.storenumber.trim().length > 0 && outlet.storeid && outlet.storeid > 0) {
              this.result.outletAddress = outlet.address
              this.result.orderType = this.$const.DELIVERY
              this.result.locationName = outlet.address
              this.result.prefectureName = outlet.prefecture_name
              this.result.cityName = outlet.city_name
              this.result.villeageName = outlet.villeage_name
              this.result.st = outlet.st
              this.result.outletId = outlet.storeid
              this.result.addressCode = outlet.address_code
              this.checkValidOutlet()
            } else {
              /**
               * handle process carryout
               * **/
              let geocoder = new google.maps.Geocoder()
              var vm = this
              let delivery_message = vm.$t('modal.delivery_message')
              geocoder.geocode({'address': this.searchAutoComplete}, function (results, status) {
                if (status === 'OK') {
                  let lat = results[0].geometry.location.lat()
                  let lng = results[0].geometry.location.lng()

                  if (!lng || !lat) {
                    vm.message = vm.$t('modal.delivery_message')
                    return false
                  }

                  let val = lng + ',' + lat
                  let data = {location: val, order_type: 'C', limit: 5}
                  vm.message = ''
                  vm.axios.apiOutlet.checkLocation(data, function (response) {
                    vm.searchLocation = false
                    vm.outletList = response.data.data.items
                    if (vm.outletList.length <= 0) {
                      vm.message = delivery_message
                    } else {
                      vm.localisation_message = ''
                      vm.message = delivery_message  + ' ' + vm.$t('collection_hut_instead')
                      vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
                      vm.onActiveCollectionForSuggestStore()
                    }
                  }, function (error) {
                    console.log(`error: ${error}`)
                    vm.message = delivery_message
                  })
                } else {
                  vm.localisation_message = delivery_message
                }
              })
            }
          } else {
            this.searchLocation = true
            this.searchAutoComplete = outlet.address
            this.getLatLog()
          }
        }
      },
      /**
       * Checking outlet is available
       * */
      checkValidOutlet() {
        // check time outlet
        if (this.empty(this.result)) {
          return false
        }
        var vm = this
        let timeObject = {
          order_time: this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''), this.$disposition.getByKey(this, 'collectionTimeValue', '')),
          advance_order: this.$disposition.getByKey(this, 'advanceOrder', 0) || 0
        }
        let data = {
          order_type: this.orderType.charAt(0),
          order_time: timeObject.order_time,
          advance_order: timeObject.advance_order,
          outlet_id: this.result.outletId
        }
        let advanceMessage = vm.$t('modal.advance_order_message')
        let uavalableMessage = vm.$t('message_find_outlet_unavailable')
        let notopenMessage = vm.$t('localization.notopen')
        this.axios.apiOutlet.checkOutletAvailable(data,
          function (response) {
            response = response.data
            if (response.status) {
              let data = vm.$disposition.get(vm)
              response = response.data.item
              // set data
              data.prefectureName = vm.result.prefectureName || ''
              data.cityName = vm.result.cityName || ''
              data.villeageName = vm.result.villeageName || ''
              data.st = vm.result.st || ''
              data.lat = response.lat
              data.long = response.long
              data.postalCode = response.zip
              data.locationName = vm.result.locationName
              data.outletAddress = response.address
              data.orderType = vm.result.orderType
              data.outletId = response.id
              data.outletName = response.name
              data.outletCode = response.code
              data.outletPhone = response.phone
              data.addressCode = vm.result.orderType == vm.$const.DELIVERY ? vm.result.addressCode : ''
              data.advanceOrder = vm.$disposition.getByKey(vm, 'advanceOrder', 0) || 0
              data.tier = response.tier
              data.minCart = response.min_cart
              data.houseNo = vm.result.houseNo || ''
              data.landmark = vm.result.landmark || ''
              data.unitNo = vm.result.unitNo || ''
              data.quoteTime = response.quote_time
              data.timezone = response.timezone
              data.customize = response.customize || {}
              data.takeaWayLess = vm.result.orderType == vm.$const.CARRYOUT ? (vm.result.takeaWayLess || 0) : 0
              vm.disposition = data
              let cart = vm.$cart.get(vm)
              if (data.takeaWayLess) {
                vm.setShowModalTakeAwayLess(true)
              }
              if (cart.uuid) {
                vm.$modal.show('dialog', {
                  text: vm.$t('confirm.remove_cart'),
                  buttons: [
                    {
                      title: vm.$t('button_yes'),
                      handler: () => {
                        vm.proceessDispostion()
                        vm.$root.$emit('onReInitHeader')
                      }
                    },
                    {
                      title: vm.$t('button_close')
                    }
                  ]
                })
              } else {
                vm.proceessDispostion()
                vm.$root.$emit('onReInitHeader')
              }
            } else if (response.message && response.message != '') {
              vm.$notify({
                type: 'warn',
                title: response.message
              })
            }
          },
          function (error) {
            vm.outletList = []
            vm.addressList = []
            error = error.error
            let message = false
            if (error.message) {
              message = error.message
            }
            vm.eventTrackingLocalisationError({id: 'error-localization', error: 'invalid-localisation'})
            /*DEAD TRACKING*/
            if (vm.$const.LOCALIZATION_CODE.DELIVERY_DEADZONE.indexOf(error.code) > -1) {
              if (error.data && error.data.division && error.data.division.C && error.data.division.D) {
                if (error.data.division.C === 2 && error.data.division.D === 2) {
                  vm.eventTrackingHutClosed(data.outlet_id)
                } else {
                  vm.eventTrackingDeliveryDeadZone('UnAvailable')
                }
              }
            } else if (vm.$const.LOCALIZATION_CODE.HUT_CLOSED.indexOf(error.code) > -1) {
              vm.eventTrackingHutClosed(data.outlet_id)
            } else if (vm.$const.LOCALIZATION_CODE.HUT_BOUNCING.indexOf(error.code) > -1) {
              vm.evenTrackingHutIsBouncing(data.outlet_id)
            }
            /*END*/

            if (error.code == vm.$const.LOCALIZATION_CODE.UNAVALIABLE) {
              vm.localisation_message = uavalableMessage
              // message = vm.$t('message_find_outlet_unavailable')
              // vm.$modal.show('dialog', {
              //   text: message,
              //   buttons: [
              //     {
              //       title: vm.$t('button_close')
              //     }
              //   ]
              // })
            } else if (error.code == vm.$const.LOCALIZATION_CODE.NOTRECEIPT) {
              vm.localisation_message = notopenMessage
              // message = vm.$t('localization.notopen')
              // vm.$modal.show('dialog', {
              //   text: message,
              //   buttons: [
              //     {
              //       title: vm.$t('button_close'),
              //       handler: () => {
              //         vm.$modal.hide('dialog')
              //         vm.$session.remove('cart')
              //         vm.$session.remove('disposition')
              //         vm.$root.$emit('cartUpdate')
              //         vm.$root.$emit('onReInitHeader')
              //       }
              //     }
              //   ]
              // })
            } else if (error.code == vm.$const.CHECKOUT_SHOW_ASAP.HUTFE_14) {
              message = vm.$t('order.error_code.code14', {
                'store_name': error.data.name,
                'store_phone': error.data.phone
              })
              vm.localisation_message = message
              vm.showPopupTime = true
              // vm.$modal.show(ASAPPopup, {
              //   outletId: error.data.id,
              //   orderType: vm.orderType,
              //   outletDataLocalization: vm.result,
              //   hideASAP: 'true',
              //   message: message
              // })
            } else {
              message = advanceMessage
              vm.localisation_message = message
              // vm.$modal.show(ConfirmOrderAdvance, {message: message, outletId: vm.result.outletId, outletDataLocalization: vm.result, orderType: vm.orderType})
              // vm.$modal.show(ASAPPopup, {
              //   outletId: vm.result.outletId,
              //   orderType: vm.orderType,
              //   outletDataLocalization: vm.result,
              //   hideASAP: 'true',
              //   message: message
              // })
              vm.showPopupTime = true
            }
          }
        )
        this.clearOutlet()
        if(this.isPopup)
          this.$emit('close')
      },
      proceessDispostion() {
        this.$disposition.set(this, this.disposition)
        this.setDisposition(this.disposition)

        this.showHideMap(true)
        this.$session.remove('cart')
        this.$root.$emit('cartUpdate')

        this.eventTrackingLocalisationSuccess(this)
        if (this.isReInitHeader) {
          this.$root.$emit('onReInitHeader')
        }
        if (this.$route.query.callback && this.$route.query.callback.length > 0) {
          this.$root.$emit('reloadDataCategory')
          this.$router.push(this.$route.query.callback)
        } else if (this.currentPath) {
          this.$root.$emit('reloadDataCategory')
          this.$router.push(this.currentPath)
        } else {
          if(!this.isPopup) {
            //this.$root.$emit('onProcessChangeCategory')
            this.callEventBus(this.$const.EVENT_BUS.LOAD_CATEGORY, true)
            this.redirectToPage(this.$const.SLUG_LIST.DEAL, this.$route.query)
          }
          
        }
      },
      /**
       * Search stores by free text
       * */
      searchByAddress() {
        var ref = this
        this.clearMessage()
        this.addressList = []
        this.outletList = []
        if (!this.searchAutoComplete) {
          return false
        }
        this.mode = 'free'
        // this.locationCenter = {lat: 0, lng: 0}
        this.loadingFreeText = true
        ref.message = ''
        this.axios.apiOutlet.getNextLevelData({
          address: this.searchAutoComplete,
          order_type: 'D',
          limit: 10,
          client_id: 1
        }, function (response) {
          ref.addressList = response.data.data.items
          if (ref.addressList.length <= 0) {
            ref.message = ref.$t('localization.stores_404')
          }
          ref.loadingFreeText = false
        }, function (error) {
          console.log(`error: ${error}`)
          ref.message = ref.$t('localization.stores_404')
          ref.loadingFreeText = false
        })
      },
      /**
       * Search stores by zip code
       * */
      searchByZipCode() {
        var zipcode
        this.clearMessage()
        this.errorPostalCode = ''
        this.mode = 'zip'

        this.addressList = []
        this.outletList = []
        zipcode = this.searchZipCode.replace('', '').replace(/[\uff01-\uff5e]/g,
          function (ch) {
            return String.fromCharCode(ch.charCodeAt(0) - 0xfee0)
          }
        )
        if (!this.searchZipCode) {
          if (!this.isMobile()) {
            this.errorPostalCode = 'message_empty_postcode'
          } else {
            this.errorPostalCode = 'message_empty_postcode_mobile'
          }
          return false
        }
        if (zipcode.length != 7) {
          if (!this.isMobile()) {
            this.errorPostalCode = 'localization.zipcode.stores_404'
          } else {
            this.errorPostalCode = 'localization.zipcode.stores_404_mobile'
          }
          return false
        }
        var vm = this
        this.loadingZip = true
        vm.message = ''
        let store404 = vm.$t('localization.zipcode.stores_404')
        this.$bus.$emit('loading', 'block')
        this.axios.apiOutlet.getOutletByAddressCode({zip_code: zipcode}, function (response) {
          vm.loadingZip = false
          if (response.data.data.items.length <= 0) {
            let geocoder = new google.maps.Geocoder()
            geocoder.geocode({'address': zipcode}, function (results, status) {
              if (status === 'OK') {
                let lat = results[0].geometry.location.lat()
                let lng = results[0].geometry.location.lng()

                if (!lng || !lat) {
                  vm.message = store404
                  return false
                }
                vm.showDrawMap(lat, lng)
              } else {
                vm.message = store404
              }
            })
          } else {
            if (vm.$route.query.callback) {
              if(vm.isPopup) vm.$emit('close')
              vm.$router.push({
                'name': 'test-localization', params: {zip: zipcode, currentPath: vm.currentPath || false},
                query: {callback: vm.$route.query.callback}
              })
            } else {
              if(vm.isPopup) vm.$emit('close')
              vm.$router.push({'name': 'test-localization', params: {zip: zipcode, currentPath: vm.currentPath || false}})
            }
          }
          vm.$bus.$emit('loading', 'none')
        }, function (error) {
          console.log(`error: ${error}`)
          vm.loadingZip = false
          vm.message = store404
          vm.$bus.$emit('loading', 'none')
        })
      },
      /**
       * Search stores by location
       * */
      searchByLocation(lat, lng) {
        this.locationCenter.lat = lat
        this.locationCenter.lng = lng
        this.mode = 'location'
        this.outletList = []
        this.addressList = []
        if (!lng || !lat) {
          return false
        }
        let val = lng + ',' + lat
        let data = {location: val, order_type: this.orderType.charAt(0), limit: 5}
        var vm = this
        vm.message = ''
        this.axios.apiOutlet.checkLocation(data, function (response) {
          vm.searchLocation = false

          vm.outletList = response.data.data.items
          if (vm.outletList.length <= 0) {
            vm.message = vm.$t('localization.not_store_carryout')
          }
        }, function (error) {
          vm.searchLocation = false
          console.log(`error: ${error}`)
          let text = vm.$t('localization.not_store_carryout')
          if (error.code && error.code == 'ECONNABORTED') {
            text = vm.$t('localization.location_404')
          }
          vm.message = text
        })
      },
      showMapWithLocation() {
        let latlng = new google.maps.LatLng(this.locationObject.lat, this.locationObject.lng)

        var _marker = null
        var vm = this
        _marker = new google.maps.Marker({
          position: latlng,
          map: this.map,
          draggable: true,
          animation: google.maps.Animation.BOUNCE
        })
        this.map.setCenter(_marker.getPosition())

        google.maps.event.addListener(_marker, 'dragend', function () {
          vm.map.setCenter(_marker.getPosition())

          vm.geocodePosition(_marker.getPosition())
        })
      },
      geocodePosition(pos) {
        this.$root.$emit('onSetMessageMap', '')
        var vm = this
        if (!pos.lat() || !pos.lng()) {
          vm.$root.$emit('onSetMessageMap', vm.$t('localization.zipcode.stores_404'))
          return false
        }
        this.locationObject.lat = pos.lat()
        this.locationObject.lng = pos.lng()
      },
      triggerOrder() {
        var vm = this
        let val = this.locationObject.lng + ',' + this.locationObject.lat
        let data = {location: val, order_type: 'C', limit: 5, order_time: vm.convertDateTimeToUTC(''), advance_order: 0}
        vm.message = ''
        vm.axios.apiOutlet.checkLocation(data, function (response) {
          vm.searchLocation = false

          vm.outletList = response.data.data.items
          if (vm.outletList.length <= 0) {
            vm.$root.$emit('closeDrawMapModal')
            vm.message = vm.$t('zipcode_notfound')
          } else {
            vm.$root.$emit('closeDrawMapModal')
            vm.searchAutoComplete = vm.searchZipCode
            vm.localisation_message = ''
            vm.message = vm.$t('modal.delivery_message') + ' ' + vm.$t('collection_hut_instead')
            vm.onActiveCollectionForSuggestStore()
          }
        }, function (error) {
          console.log(`error: ${error}`)
          vm.$root.$emit('closeDrawMapModal')
          vm.message = vm.$t('zipcode_notfound')
        })
      },

      /**
       * Draw maps
       */
      drawMaps() {
        var vm = this
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null)
        }
        this.markers = []
        if (this.locationCenter.lat != 0 && this.locationCenter.lng != 0) {
          let latlng = new google.maps.LatLng(this.locationCenter.lat, this.locationCenter.lng)
          let nMarket = new google.maps.Marker({
            position: latlng,
            map: this.map,
            draggable: false,
            icon: 'https://static.pizzahut.jp/jp/icons/pin.png'
          })
          this.markers.push(nMarket)
        }
        let bounds = new google.maps.LatLngBounds()
        bounds.extend(new google.maps.LatLng(this.markers[0].getPosition().lat(), this.markers[0].getPosition().lng()))
        for (let i = 0; i < this.outletList.length; i++) {
          let latlng = new google.maps.LatLng(this.outletList[i].lat, this.outletList[i].long)
          let index = i + 1
          let icon = {
            url: 'https://static.pizzahut.jp/jp/icons/gray-logo.png',
            scaledSize: new google.maps.Size(40, 40)
          }
          let contentString = '<div id="content">' +
            '<div id="siteNotice">' +
            '</div>' +
            '<h1 id="firstHeading" class="firstHeading">' + this.outletList[i].name + ' ' + this.$t('store') + '</h1>' +
            '<div id="bodyContent">' +
            '<p>' + this.outletList[i].address + '</p>' +
            '<p><button class="btn btn-success maps-infowindow t13 " style="padding: 8px 20px" onclick="infowindowClick(' + i + ')">' + this.$t('select') + '</button></p>' +
            '</div>' +
            '</div>'

          var infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 200
          })

          let marker = new google.maps.Marker({
            position: latlng,
            map: this.map,
            draggable: false,
            outletIndex: i,
            outlet: this.outletList[i],
            infowindow: new google.maps.InfoWindow({
              content: contentString
            }),
            title: this.outletList[i].address,
            icon: icon,
            hoverIcon: 'https://deo515rx9pz7c.cloudfront.net/icons/red-logo.png',
            originIcon: 'https://static.pizzahut.jp/jp/icons/gray-logo.png'
          })
          this.markers.push(marker)
          if (this.outletList[i].distance <= 10) {
            bounds.extend(new google.maps.LatLng(this.markers[i].getPosition().lat(), this.markers[i].getPosition().lng()))
          }
          marker.addListener('mouseover', function (e) {
            this.highlight = this.outletIndex
          })
          marker.addListener('click', function (e) {
            for (let i = 0; i < vm.markers.length; i++) {
              if (vm.markers[i].infowindow) {
                vm.markers[i].infowindow.close()
              }
            }
            vm.onChangeOutlet(this.outletIndex)
            this.infowindow.open(this.map, marker)
          })
          marker.addListener('mouseout', function (e) {
            this.highlight = null
          })
        }
        this.map.fitBounds(bounds)
        // if (window.innerWidth < 768) {
        //   this.map.setZoom(7)
        // } else {
        //   this.map.setZoom(11)
        // }
      },
      loadScriptMap() {
        (function (d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0]
          if (d.getElementById(id)) return
          js = d.createElement(s);
          js.id = id
          js.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDKYCZ1DFNXUqDlouh_gmdpCcd05JOxp8Q&libraries=places&language=ja&region=JP'
          fjs.parentNode.insertBefore(js, fjs)
        }(document, 'script', 'google-maps-jssdk'))
      },
      /**
       * Trigger before open modal popup
       * */
      beforeOpen(event) {
        this.initMap()
        this.drawMaps()
        this.onChangeOutlet(0)
        document.body.classList.add('modal-open')
      },
      beforeOpenDraw(event) {
        this.initMap()
        this.showMapWithLocation()
        document.body.classList.add('modal-open')
      },
      /**
       * Trigger before close modal popup
       * */
      beforeClose(event) {
        this.mapOpen = false
        document.body.classList.remove('modal-open')
      },
      beforeCloseDraw(event) {
        document.body.classList.remove('modal-open')
      },
      clearShowPopupMessage(json) {
        this.$notify({
          group: 'notifications',
          clean: true,
          speed: 1
        })

        this.$notify(json)
      },
      switchSearchByAddress() {
        this.showDefaultSearchDelivery = true
      },
      updateZipcodeValue(val) {
        this.searchZipCode = val
      },
      changeAddress() {
        if (this.hasDisposition) {
          this.resetDisposition()
        } else {
          this.$route.query.isShowWarning = 1
          this.searchAutoComplete = ''
          this.lat = 0
          this.lng = 0
          this.$refs.autoComplete.focus()
        }
      },
      initGenerateTimeSlot() {
        let id = 0
        if (typeof this.result.outletId !== 'undefined' && this.result.outletId) {
          id = this.result.outletId
        } else if (!this.empty(this.$disposition.getByKey(this, 'outletId', ''))) {
          id = this.$disposition.getByKey(this, 'outletId', '')
        }
        var vm = this
        let order_type = this.orderType || this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
        let subTradezoneId = this.$disposition.getByKey(this, 'subtradezoneid', '')
        this.axios.apiOutlet.getOutletOpeningHours({
          outletId: id,
          order_type: order_type.charAt(0),
          subtradezoneid: subTradezoneId
        }, function (response) {
          let items = response.data.data.items
          if (!vm.empty(items)) {
            let result = {}
            result = vm.setDataTimeSlot(vm, items, items[0].info.timezone)
            vm.timezone = items[0].info.timezone
            vm.openingDateTime = result.openingDateTime
            vm.hours = result.hours
            vm.choiceDay = result.choiceDay
            vm.choiceHour = result.choiceHour
            vm.clearOutlet()
            vm.$forceUpdate()
          }
        })
      },
      setTime() {
        var timepicker = {'pickedDay': this.choiceDay, 'pickedHours': this.choiceHour}
        let data = this.$disposition.get(this)
        data.collectionTime = timepicker
        data.collectionTimeText = this.choiceDay + ' ' + this.choiceHour
        let time = this.choiceHour.split(' - ')
        if (time.length > 1) {
          time = time[1]
        } else if (time.length > 0) {
          time = time[0]
        }
        data.collectionTimeValue = this.choiceDay + ' ' + time
        data.timezone = this.timezone
        data.advanceOrder = 1
        if (this.choiceHour == this.$t('asap')) {
          data.advanceOrder = 0
        }
        this.$disposition.set(this, data)
        // call api to update order time
        this.$cart.updateOrderTime(this, {'order_time': this.getTimePickerDate(this)})
        this.checkValidOutlet()
      },
      handleAction() {
        if (this.showPopupTime) {
          this.initGenerateTimeSlot()
          this.resetErrorAction()
        }
      },
      resetErrorAction() {
        this.localisation_message = ''
        this.switchToCollection = false
        this.switchToDelivery = false
        this.showPopupTime = false
        this.$session.remove('cart')
        this.$session.remove('disposition')
      },
      checkGeoLocation() {
        let vm = this
        navigator.permissions.query({
          name: 'geolocation'
        }).then(function (result) {
          if (result.state == 'granted') {
            vm.geo_message_error = ''
          } else if (result.state == 'prompt') {
            vm.geoMessage = vm.$t('geo_notification_message')
            vm.geo_message_error = ''
          } else if (result.state == 'denied') {
            vm.geo_message_error = vm.$t('geo_notificaton_blocked')
          }
        });
      },
      checkGeoLocation() {
        let vm = this
        navigator.permissions.query({
          name: 'geolocation'
        }).then(function (result) {
          if (result.state == 'granted') {
            vm.geo_message_error = ''
          } else if (result.state == 'prompt') {
            vm.geoMessage = vm.$t('geo_notification_message')
            vm.geo_message_error = ''
          } else if (result.state == 'denied') {
            vm.geo_message_error = vm.$t('geo_notificaton_blocked')
          }
        });
      },
    },
    components: {
      ZipcodeInput,
      vSelect
    }

  }
</script>
<style>

</style>
<style scoped>
  .black-modal {
    background-color: #313131 !important;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    opacity: 0.8;
  }

  a:focus {
    border: 1px solid #719ECE !important;
  }

  .left-icon-address {
    width: 30px;
    flex: 0 0 30px;
    padding-left: 0;
    padding-right: 0;
  }

  .contain-outlet {
    max-height: 520px;
    overflow-y: auto;
  }

  .contain-outlet .list-outlets .outlet-item {
    min-width: 400px;
  }

  .disposition-title {
    font-size: 14px;
  }

  @media (min-width: 768px) {
    .disposition-title {
      font-size: 18px;
    }
  }

  #mapLocalization {
    height: 238px;
    width: 100%;
  }

  @media screen and (min-width: 48em) {
    #mapLocalization {
      height: 455px;
    }
  }

  li.outlet-item:hover, .highlight {
    background: #3053691a;
  }

  .top-warning {
    margin: 0 30px 0;
    border-radius: 5px;
  }

  .collection::before {
    left: 80% !important;
  }

  @media screen and (max-width: 60em) {
    .left-icon-address--v2 {
      display: none;
    }
  }

  .search--hut[name="zipcode"] {
    flex: 0 0 70%;
  }

  @media screen and (max-width: 60em) {
    .search--hut[name="zipcode"] {
      padding-left: 0;
      margin-left: -2px;
    }
  }

  .btn--delivery-submit {
    flex: 0 0 30%
  }

  @media screen and (max-width: 60em) {
    .btn--delivery-submit {
      flex: 0 0 25%
    }
  }

  @media screen and (max-width: 50em) {
    .btn--delivery-submit > a.btn {
      font-size: 1.4rem;
    }
  }

  @media screen and (max-width: 23.5em) {
    .btn--delivery-submit > a.btn {
      font-size: 1.2rem;
    }
  }

  .home-icon-default {
    display: flex;
    align-items: center;
    color: #4A90E2;
    margin-left: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .switch-device--desktop {
    display: none;
  }

  @media screen and (min-width: 60em) {
    .switch-device--desktop {
      display: block;
    }
  }

  .switch-device--mobile {
    display: none;
  }

  @media screen and (max-width: 60em) {
    .switch-device--mobile {
      display: block;
    }
  }
  .time-slots {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .time-slots select {
    flex: 1;
    border: solid 1px #E5E5E5;
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
    padding: 10px;
  }

  .time-slots select.arrow-dropdown-time {
    background-image: url(http://static.phdvasia.com/nz/icons/arrow_down.png);
    background-position: calc(100% - 16px) 1em, calc(100% - 16px) 1em, calc(100% - 2.5em) .5em;
    background-size: 12px;
    background-repeat: no-repeat;
  }
  .geo-message-content {
    display: flex;
    flex-direction: row;
    background-color: #FFF8E2;
    padding: 15px;
  }

  .geo-message-title {
    font-size: 22px;
    font-weight: 700;
  }

  .icon-noti-geo {
    line-height: 1.5;
    color: #FEBC3C;
    font-size: 20px;
  }
  .localization-timeslot-title {
    font-size: 20px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeLocalizationMapZipcodeNewDesign.vue